export class MapStateNestedBackgroundMediaDto {
  mediaId: string;
  coordinates?: number[][];

  constructor(init: MapStateNestedBackgroundMediaDto) {
    this.mediaId = init?.mediaId;
    this.coordinates = init?.coordinates;
  }
}
